import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import {
  Card,
  CardHeader,
  CardMedia,
  CardContent,
  Typography,
  Icon,
  IconButton,
} from '@material-ui/core';
import Immutable from 'seamless-immutable';

import Button from '../../core/components/Button';
import ReadMore from '../../core/components/ReadMore';
import '../../../css/menuPage/components/ProductBoxComponent.scss';
import { FeatureFlags } from '../../../../src/services/functions/FeatureFlag';
import { productIcons } from '../../../services/constants/Constants';
import FeaturePizzaIcon from '../../../assets/images/feature@3x.png';
import { getCurrencySymbol, productIsOutOfStock, getImageUrl } from '../../../services/functions/Functions';
import ResourceConstants from '../../../services/constants/ResourceConstants.json';

class ProductBoxComponent extends Component {
  getLowestPrice = (items) => {
    const mutableItems = Immutable.asMutable(items, { deep: true });
    const sortedItems = mutableItems.sort((a, b) => a.price - b.price);
    return sortedItems[0].price.toFixed(2);
  }

  parseDescription = (description) => {
    const { translation } = this.props;
    const desc = description && description.replace(translation('ProductBoxComponent.vegetarian'), '').trim();
    return desc;
  }

  renderOutOfStockOverlay = () => {
    const { translation } = this.props;
    // TO-DO: Remove inline styles
    return (
      <div className="oufOfStockOverlay">
        <IconButton
          aria-label="warning"
        >
          <Icon
            color="error"
            fontSize="large"
          >
            warning
          </Icon>
        </IconButton>
        <Typography className="productBox-outOfStockText">
          {translation('ProductBoxComponent.outOfStock')}
        </Typography>
      </div>
    );
  }

  render() {
    const {
      translation, product, handleClick, currentOrderLocationId, showButton, upsell, maxBoxHeight,
    } = this.props;
    const {
      showProductImage, showProductDescription, useRoundImage, useTransparentBackground,
    } = FeatureFlags.ProductBoxComponent;
    const iconList = get(product, 'icons');
    let cardClassName = showProductDescription ? 'cardWithDescription' : 'cardNoDescription';
    if (useTransparentBackground) cardClassName = `${cardClassName} transparentBackground`;
    if (upsell) cardClassName = `${cardClassName} upsell`;
    let headerClassName = 'productBox-header';
    if (upsell) headerClassName = 'productBox-upsellHeader';
    let mediaClassName = useRoundImage ? 'media-round' : 'media';
    if (upsell) mediaClassName = 'upsell-media';
    return (
      <div id={`product${product.id}`} className="productBox-productContainer">
        {
          FeatureFlags.ProductBoxComponent.featureProduct.show
          && <img src={FeaturePizzaIcon} alt="Feature Pizza" className="featurePizzaIcon" />
        }
        <Card
          style={{ minHeight: maxBoxHeight }}
          className={cardClassName}
          onClick={() => {
            if (!productIsOutOfStock(product, currentOrderLocationId)) handleClick(product.id);
          }}
        >
          {productIsOutOfStock(product, currentOrderLocationId) && this.renderOutOfStockOverlay()}
          <div className="cardHeaderContainer">
            {
              showProductImage
                && (
                  <CardMedia
                    className={mediaClassName}
                    component="img"
                    src={
                      product.images && product.images.length > 0
                        ? product.images[0].src
                        : getImageUrl('image-placeholder.png')
                    }
                  />
                )
            }
            <CardHeader
              title={
                <div className="productBox-titleContainer">
                  {FeatureFlags.ProductBoxComponent.useUppercaseProductName ? product.name.toUpperCase() : product.name}
                  <div className="iconsContainer">
                    {
                      productIcons.map((pIcon) => {
                        if (iconList && iconList.includes(pIcon.key)) {
                          return (
                            <img
                              key={pIcon.key}
                              src={getImageUrl(`productIcons/${pIcon.key}.png`)}
                              className="productBox-productIcon"
                              alt={translation(pIcon.translation)}
                              title={translation(pIcon.translation)}
                            />
                          );
                        }
                        return null;
                      })
                    }
                  </div>
                </div>
            }
              subheader={
              product.items.length > 1
                ? `${getCurrencySymbol()}${this.getLowestPrice(product.items)} ${translation('ProductBoxComponent.andUp')}`
                : product.items.length > 0 && product.items[0] && `${getCurrencySymbol()}${product.items[0].price.toFixed(2)}`
            }
              classes={{
              content: headerClassName,
              title: 'productBox-titleText',
              subheader: 'productBox-subheader',
            }}
            />
          </div>
          {
              showProductDescription
              && (
                <CardContent classes={{ root: 'removeTopPadding' }}>
                  <ReadMore
                    charLimit={ResourceConstants.descriptionCharacterLimit}
                    textClass="productBox-description"
                    text={this.parseDescription(product.description)}
                    translation={translation}
                  />
                </CardContent>
              )
          }
          {
            showButton
            && (
              <Button
                type="primary"
                className="productBox-addToCartButton"
                overrideClass
                text={translation('ProductFlowDialog.addToCartText')}
              />
            )
          }
        </Card>
      </div>
    );
  }
}

ProductBoxComponent.propTypes = {
  showButton: PropTypes.bool,
  translation: PropTypes.func.isRequired,
  product: PropTypes.objectOf(PropTypes.any).isRequired,
  handleClick: PropTypes.func.isRequired,
  currentOrderLocationId: PropTypes.number,
  upsell: PropTypes.bool,
  maxBoxHeight: PropTypes.string,
};

ProductBoxComponent.defaultProps = {
  currentOrderLocationId: null,
  showButton: false,
  upsell: false,
  maxBoxHeight: 'inherit',
};

export default (ProductBoxComponent);
